import { getInitData } from "../telegram/init";

// In production the server serves the client on the same origin → relative URLs
const SERVER_URL = import.meta.env.VITE_SERVER_URL ?? "";

async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const initData = getInitData();

  const res = await fetch(`${SERVER_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `tma ${initData}`,
      ...options.headers,
    },
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `HTTP ${res.status}`);
  }

  return res.json();
}

export function useApi() {
  return {
    auth: () => apiFetch<any>("/api/auth/telegram", { method: "POST" }),

    getCity: (id: number) => apiFetch<any>(`/api/city/${id}`),

    getIsland: (id: number) => apiFetch<any>(`/api/island/${id}`),

    buildBuilding: (cityId: number, position: number, buildingType: string) =>
      apiFetch<any>(`/api/city/${cityId}/build`, {
        method: "POST",
        body: JSON.stringify({ position, buildingType }),
      }),

    upgradeBuilding: (cityId: number, position: number) =>
      apiFetch<any>(`/api/city/${cityId}/upgrade`, {
        method: "POST",
        body: JSON.stringify({ position }),
      }),

    assignWorkers: (cityId: number, forestWorkers: number, mineWorkers: number, scientists: number) =>
      apiFetch<any>(`/api/city/${cityId}/workers`, {
        method: "POST",
        body: JSON.stringify({ forestWorkers, mineWorkers, scientists }),
      }),

    donateToIsland: (islandId: number, cityId: number, type: "FOREST" | "MINE", amount: number) =>
      apiFetch<any>(`/api/island/${islandId}/donate`, {
        method: "POST",
        body: JSON.stringify({ type, amount, cityId }),
      }),

    getResearches: () => apiFetch<any>("/api/research"),

    startResearch: (researchType: string, cityId: number) =>
      apiFetch<any>("/api/research/start", {
        method: "POST",
        body: JSON.stringify({ researchType, cityId }),
      }),
  };
}
